<template>
     <div  class="loading-container">
      <Spin size="large" fix>正在自动登录中...</Spin>
    </div>  
</template>
<script>
export default {
  data() {

    return {
     
    };
  },
  mounted() {
    this.autoLoginFromUrl();
  },
  methods: {
    // 从URL获取参数并自动登录
    autoLoginFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const idCard = urlParams.get('idCard');
      const token = urlParams.get('token');
      const idNumberType = urlParams.get('idNumberType') || 'idCard';
      
      if (idCard && token) {
        this.loading = true;
        this.loginError = false;
        
        // 调用自动登录接口
        this.autoLogin(idCard, idNumberType, token);
      }
    },
    
    // 自动登录方法
    autoLogin(idCard, idNumberType, token) {
      var _this = this;
      _this.$http
        .get("retire-school-manage/login/getIdcardLogin", {
          params: {
            idNumberType: idNumberType,
            idCard: idCard.replace("x", "X"),
            token: token
          }
        })
        .then(function(res) {
          _this.loading = false;
          if (res.data.status === 2000) {
            // 登录成功 存token
            sessionStorage.removeItem("token_retire_school");
            let token = res.data.data.token;
            sessionStorage.setItem("token_retire_school", token);
            _this.$store.commit("ADD_TOKEN", token);

            sessionStorage.removeItem("userNameSchool");
            let userName = res.data.data.name;
            sessionStorage.setItem("userNameSchool", userName);

            sessionStorage.removeItem("idCard");
            let idCard = res.data.data.idCard;
            sessionStorage.setItem("idCard", idCard);

            sessionStorage.removeItem("idNumberType");
            let idNumberType = res.data.data.idNumberType;
            sessionStorage.setItem("idNumberType", idNumberType);

            let studentId = res.data.data.id;
            sessionStorage.setItem("studentId", studentId);
            _this.$store.commit("ADD_STUDENTID", studentId);
            _this.$router.push({ name: "home" });

          } else {
            _this.loginError = true;
            _this.errorMessage = res.data.msg || "自动登录失败";
            _this.$CustomMessageError(res.data.msg);
          }
        })
        .catch(function(error) {
          _this.loading = false;
          _this.loginError = true;
          _this.errorMessage = "网络请求失败，请检查网络连接";
          console.log(error);
          _this.$CustomMessageError("网络请求失败");
        });
    }, 
  }
};
</script>
<style>
.login-form {
  padding: 0 80px;
}

.ivu-input-large {
  padding: 20px !important;
  font-size: 18px;
}

@media screen and (max-width: 768px) {
  .login-form {
    padding: 0 16px;
  }

  .ivu-form-item {
    margin-bottom: 20px;
  }

  .ivu-form-item-label {
    text-align: left;
    padding: 0 0 10px 0;
    width: auto !important;
    font-size: 18px !important;
    line-height: 1.5;
  }

  .ivu-input-large {
    padding: 12px !important;
    font-size: 15px;
    height: 44px;
  }

  .ivu-form-item-content {
    margin-left: 0 !important;
  }

  .ivu-modal {
    width: 90%;
    margin: 0 auto;
  }

  .btn-group {
    margin-top: 40px;
  }

  .btn-wrapper {
    flex-direction: column;
    gap: 32px;
    width: 100%;
  }

  .submit-btn, .reset-btn {
    width: 100%;
    margin: 0 !important;
    height: 46px;
    font-size: 16px;
    border-radius: 6px;
  }
}

@media screen and (max-width: 375px) {
  .ivu-form-item-label {
    font-size: 15px;
  }

  .ivu-input-large {
    font-size: 14px;
  }
}

.btn-group {
  margin-top: 20px;
}

.btn-wrapper {
  display: flex;
  gap: 16px;
}

.submit-btn, .reset-btn {
  padding: 8px 30px;
  font-size: 20px;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 18px;
}
</style>
